module.exports = __webpack_public_path__ + "img/Cube.311546bb.svg";